import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'
import { MarketCategoryType } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySelector',
  props: {
  active: Boolean,

  type: {
    type: String as PropType<MarketCategoryType>,
    required: true
  }
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (e: 'click', state: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





function handleTypeClick() {
  emit('click', props.type)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["text-xs cursor-pointer select-none px-3 py-2 rounded font-medium", [
      __props.active
        ? 'bg-blue-500 bg-opacity-20 text-blue-500  hover:text-blue-600'
        : 'text-gray-300  hover:text-blue-500'
    ]]),
    onClick: handleTypeClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})